import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources: {
      en: { translations: en },
      es: { translations: es },
    },
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;